import { GatewayModal, RouterProvider } from '@bnnvara/accounts';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import { useLink } from '../Link';
import createGatewayRouter from './routerHelper';

/**
 * This container provides the custom ComposableRouter
 * (which is Brandsite specific) to the Account's RouterProvider
 * This makes the Accounts Gateway 'router based' meaning it uses query parameters
 * in the url to navigate between screens. If the queryParam is empty or removed,
 * the gateway modal will be closed.
 *
 * This container should be loaded 'after' all the other providers, but before the pages
 * render. This is required, because we need the ComposableRouter and that router depends on
 * a brands query.
 */
const Account = ({ children }) => {
  const router = useRouter();
  const { createHref, setQueryParams, removeQueryParams } = useLink();

  const gatewayRouter = createGatewayRouter({
    router,
    createHref,
    setQueryParams,
    removeQueryParams,
    queryParamName: 'dialoog',
  });

  return (
    <RouterProvider router={gatewayRouter}>
      <Fragment>
        <GatewayModal screenName={router.query.dialoog} />
        {children}
      </Fragment>
    </RouterProvider>
  );
};

Account.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Account;
